import type { TextualDisplay, TextualDisplayValue } from "@ebay/experience-types-ebay";
export interface Input {
  displayPrice?: TextualDisplayValue;
  listingFormat?: TextualDisplay;
  isBoxed?: boolean;
}
$ const { displayPrice, listingFormat, isBoxed } = input;

<p class=["item-price", isBoxed ? "item-price--boxed" : ""]>
  <fe-textual-display model=displayPrice/>
  <if(listingFormat)>
    <p class="item-price-listing-format">
      <fe-textual-display model=listingFormat/>
    </p>
  </if>
</p>
